import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { viewPackage, togglePackage } from '~/services/api'
import { PackageDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import $ from 'jquery'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    data: Array,
    packages: Array,
    loading: Boolean,
}

export class AbstractPackageViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            packages: [
                {
                    code: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    name: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    currency: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    price: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    school: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    status: {
                        field: 'badge',
                        modal: true,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this.toggle = this.toggle.bind(this)
        this._handleChange = this._handleChange.bind(this)
    }

    componentDidMount() {
        this.loadPackage()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    toggle(id) {
        togglePackage(id, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadPackage()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    loadPackage() {
        this._handleChange('loading', true)
        viewPackage(this.props.token).then((response) => {
            this._handleChange('loading', false)
            let packages = []
            packages.push(this.state.packages[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                response.data.package.map((item, index) => {
                    const data: PackageDTO = item
                    let text = null
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            badge: 'table-green',
                            modal: 'modal_package_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            badge: 'table-red',
                            modal: 'modal_package_' + index,
                        }
                    }
                    const tableData = {
                        code: {
                            text: data.code,
                        },
                        name: {
                            text: data.name,
                        },
                        currency: {
                            text: data.currency,
                        },
                        price: {
                            text: data.price,
                        },
                        school: {
                            text: data.school_count,
                        },
                        status: text,
                        action: {
                            text: 'Edit',
                            route: route.superadmin.package.edit + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    packages.push(tableData)
                })
            }
            this.setState({
                data: dataList,
                packages,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
